import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TriviaService } from '../trivia.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ModalService } from '@core/modals/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';
import { ITriviaRegularForm } from '../interfaces/trivia.interface';

@Component({
  selector: 'app-trivia-regular-modal',
  imports: [FormFieldComponent, ReactiveFormsModule],
  templateUrl: './trivia-regular-modal.component.html',
  styleUrl: './trivia-regular-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class TriviaRegularModalComponent {
  private readonly triviaService = inject(TriviaService);
  private readonly modalService = inject(ModalService);
  private readonly toastrService = inject(ToastrService);

  question = new FormControl<string>('', [Validators.required]);
  correctAnswer = new FormControl<string>('', [Validators.required]);
  correctAnswer2 = new FormControl<string>('', [Validators.required]);
  correctAnswer3 = new FormControl<string>('', []);
  correctAnswer4 = new FormControl<string>('', []);
  reward = new FormControl<number>(1, [Validators.required, Validators.min(1)]);

  triviaRainForm = new FormGroup({
    question: this.question,
    correctAnswer: this.correctAnswer,
    correctAnswer2: this.correctAnswer2,
    correctAnswer3: this.correctAnswer3,
    correctAnswer4: this.correctAnswer4,
    reward: this.reward,
  });

  async onSubmit() {
    this.triviaRainForm.markAllAsTouched();

    if (!this.triviaRainForm.valid) {
      this.toastrService.error(
        'Form is not valid. Please check the inputs. All fields are required, min reward is 1'
      );
      return;
    }

    const formValues = this.triviaRainForm.value;

    const triviaRegular: ITriviaRegularForm = {
      question: formValues.question!,
      answers: [
        formValues.correctAnswer!,
        formValues.correctAnswer2!,
        formValues.correctAnswer3!,
        formValues.correctAnswer4!,
      ].filter(Boolean) as string[],
      reward: Number(formValues.reward!),
    };

    try {
      await this.triviaService.createRegularTrivia(triviaRegular);
      this.toastrService.success('Trivia has been created successfully');
      this.modalService.close();
    } catch (error) {
      console.log(
        '🚀 ~ TriviaRegularModalComponent ~ onSubmit ~ error:',
        error
      );
    }
  }
}
